import { useContext, useEffect, useState } from 'react'
import { CheckBoxButton } from './CheckBoxButton'
import { PrimaryButton } from './PrimaryButton'
import { UnderLinedButton } from './UnderlinedButton'
import { MobileNumberInput } from './MobileNumberInput'
import { LoginContext } from './LoginOrSignUp'
import useTranslation from '../hooks/useTranslation'

export const LoginOrSignUpModal = () => {
  const translation = useTranslation()
  const [loading, setLoading] = useState(false)
  const [ischeckBoxClicked, setCheckBoxClicked] = useState(true)
  const [error, setError] = useState({ isPresent: false, msg: translation?.incorrectCredentials })
  const { loginContinueHandler, handleMobileNumber, isChangeNumber, countryCode, mobileNumber } =
    useContext(LoginContext)

  const handleCheckBox = () => {
    setCheckBoxClicked((prv) => !prv)
  }

  useEffect(() => {
    if (/^[0-5]\d{9}$/.test(mobileNumber) && mobileNumber !== '') {
      setError({ isPresent: true, msg: translation?.incorrectCredentials })
    } else {
      setError({ isPresent: false })
    }
  }, [mobileNumber])

  const continueHandler = async () => {
    setLoading(true)
    const isError = await loginContinueHandler()
    if (isError) setError({ isPresent: true, msg: translation?.pleaseTryAgain })
    setLoading(false)
  }

  const openPath = (pathname) => {
    window.open(pathname)
  }

  return (
    <div className="font-noto-sans">
      {isChangeNumber ? (
        <div className="px-[12px]">
          <div className="text-xl font-bold leading-22 text-black">
            {translation?.enterNewMobileNumber}
          </div>
          <div className="mt-xl">
            <div className="flex text-sm font-normal leading-16 text-darkGray">
              {translation?.mobileNumber}
              <div className="text-baseGray ">. {translation?.anOtpWillBeSentToThisNumber}</div>
            </div>
            <MobileNumberInput
              {...{
                id: 'advertiser_login_mobile_number',
                onChange: handleMobileNumber,
                countryCode: countryCode?.current,
                mobileNumber,
                error: error?.isPresent || mobileNumber?.length > 10,
                errorMsg: error?.msg,
                disabled: loading
              }}
            />
          </div>
        </div>
      ) : (
        <div className="px-[12px]">
          <div className="text-xl font-bold leading-22 text-black">
            {translation?.welcomeToLokal}!
          </div>
          <div className="mt-sm text-md font-bold leading-22 text-heading">
            {translation?.loginOrSignup}
          </div>

          <div className="mt-sm text-base font-normal leading-22 text-darkGray">
            {translation?.otpDiscription}{' '}
          </div>
          <div className="mt-xl">
            <div className="flex text-sm font-normal leading-16 text-darkGray">
              {translation?.mobileNumber}
            </div>
            <MobileNumberInput
              {...{
                id: 'advertiser_login_mobile_number',
                onChange: handleMobileNumber,
                countryCode: countryCode?.current,
                mobileNumber,
                error: error?.isPresent || mobileNumber?.length > 10,
                errorMsg: error?.msg,
                disabled: loading
              }}
            />
          </div>
          <div className="mt-[20px] flex items-center" onClick={handleCheckBox}>
            <CheckBoxButton
              className="h-[18px] w-[18px] accent-primary"
              isClicked={ischeckBoxClicked}
            />
            <div className="ml-[8px] flex flex-wrap text-[12px] font-normal leading-[16.34px] text-[#19191A]">
              {translation?.iAgreeToThe}
              <UnderLinedButton
                {...{
                  title: translation?.termsAndConditions,
                  className: 'mx-[2px] font-normal',
                  onClick: () => openPath(`${process.env.NEXT_PUBLIC_BASE_URL}/termsofcontent/`)
                }}
              />
              {translation?.and}
              <UnderLinedButton
                {...{
                  title: translation?.privacyPolicy,
                  className: 'ml-[2px] font-normal',
                  onClick: () => openPath(`${process.env.NEXT_PUBLIC_BASE_URL}/?page_id=3`)
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="mt-[28px] p-[12px] pb-[12.72px] shadow-primaryButton">
        <PrimaryButton
          {...{
            title: translation?.continue,
            disabled: !(ischeckBoxClicked && mobileNumber?.length === 10) || error.isPresent,
            onClick: continueHandler,
            loading
          }}
        />
      </div>
    </div>
  )
}
